import { useState, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import Header from './architecture/Header';
import Footer from './architecture/Footer';
import Home from './architecture/Home';
import Projects from './architecture/Projects';
import About from './architecture/About';
import Commission from './architecture/Commission';

export default function ArchitectureTemplate() {
  const [page, setPage] = useState('home');
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' }); }, [page]);
  return (
    <div className="min-h-screen bg-[#DADCD6]" data-testid="arch-template-root">
      <Header page={page} setPage={setPage} />
      <AnimatePresence mode="wait">
        <motion.main key={page} initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.3 }} data-testid={`arch-page-${page}`}>
          {page === 'home' && <Home setPage={setPage} />}
          {page === 'projects' && <Projects setPage={setPage} />}
          {page === 'about' && <About setPage={setPage} />}
          {page === 'commission' && <Commission setPage={setPage} />}
        </motion.main>
      </AnimatePresence>
      <Footer setPage={setPage} />
    </div>
  );
}
